import upIcon from '@/assets/dashboard-icons/up-icon.svg';
import downIcon from '@/assets/dashboard-icons/down-icon.svg';
import { useUserLanguage } from '@/customHooks';
import type { LanguageType } from '@/custom-types';

const BOX_LABELS: Record<LanguageType, Record<'income' | 'expenses' | 'benefit', string>> = {
  en: { income: 'Income', expenses: 'Expenses', benefit: 'Benefit' },
  es: { income: 'Ingresos', expenses: 'Gastos', benefit: 'Beneficio' },
};

type Props = {
  variant: 'income' | 'expenses' | 'benefit';
  amount: string;
  percentage: string;
  isPositive?: boolean;
};

export const IncomeBox = ({ variant, amount, percentage, isPositive }: Props) => {
  const userLanguage = useUserLanguage();
  const title = BOX_LABELS[userLanguage][variant];
  const percentageIcon = isPositive ? upIcon : downIcon;
  const trendAlt =
    userLanguage === 'es'
      ? isPositive
        ? 'tendencia al alza'
        : 'tendencia a la baja'
      : isPositive
        ? 'trend up'
        : 'trend down';

  return (
    <div className="rounded-xl bg-white p-4 shadow-[0_14px_32px_rgba(15,23,42,0.16)]">
      <h4 className="m-0 text-[0.9rem] font-normal text-[#999]">{title}</h4>
      <div className="mt-2 flex items-center gap-2">
        <div className="text-[1.3rem] font-bold text-[#00356b]">{amount}</div>
        <div className={`flex items-center gap-1 text-[0.8rem] font-bold ${isPositive ? 'text-[#2ecc71]' : 'text-[#e74c3c]'}`}>
          <img className="h-[5px] w-[9px]" src={percentageIcon} alt={trendAlt} />
          {percentage}
        </div>
      </div>
    </div>
  );
};
